import { render, staticRenderFns } from "./submitBtn.vue?vue&type=template&id=8e78503a&scoped=true&"
import script from "./submitBtn.vue?vue&type=script&lang=ts&"
export * from "./submitBtn.vue?vue&type=script&lang=ts&"
import style0 from "./submitBtn.vue?vue&type=style&index=0&id=8e78503a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e78503a",
  null
  
)

export default component.exports